// extracted by mini-css-extract-plugin
export default {"verify":"Alert_verify__jZ4z6","row":"Alert_row__dsqtY","verifyButton":"Alert_verifyButton__srsHW"};